import feathersClient, {makeServicePlugin, BaseModel} from "@/feathers/feathers-client";
import {clearList, updateItems, addItemsAgg} from "@/vuex/feathers-vuex-plugins/custom-mutations";

class QueueDashboardAgentAggregates extends BaseModel {

  constructor(data, options) {
    super(data, options);
  }

  static modelName = 'QueueDashboardAgentAggregates';

}

const servicePath = 'queueDashAgentAggregates';
const servicePlugin = makeServicePlugin({
  enableEvents: false,
  idField: 'peerName',
  Model: QueueDashboardAgentAggregates,
  service: feathersClient.service(servicePath),
  servicePath,
  mutations: {
    updateItems(state, items) {
      updateItems(state, items)
    },
    updateItem(state, item){
      updateItems(state, [item])
    },
    clearList(state){
      clearList(state)
    },
    addItems(state, items){
      addItemsAgg(state, items)
    },
    addItem(state, item) {
      state = [...state, item];
    }
  }
});

export default servicePlugin;
